
<template>
  <!-- 虚拟表费用查询 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
   <!-- 列表 -->
    <div>
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
         </div>
         <div class="sw-wrap">
           <el-descriptions title="" size="mini" :column="2" border :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
             <el-descriptions-item label="仪表类型" size="mini">
               <el-select size="mini" style="width: 100%" v-model="data.meter_type_id" filterable clearable placeholder="类型" class="kuan">
                 <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
               </el-select>
             </el-descriptions-item>
             <el-descriptions-item label="当前房产">
               <el-select style="width:100%" v-model="data.HouseName" size="mini" filterable remote clearable reserve-keyword placeholder="可搜索房产" :remote-method="remoteMethod" :loading="loading">
                  <el-option v-for="item in selectList" :key="item.house" :label="item.house" :value="item.house"></el-option>
                </el-select>
             </el-descriptions-item>
             <el-descriptions-item label="户号">
               <el-input size="mini" placeholder="户号" v-model="data.house_number" clearable></el-input>
             </el-descriptions-item>
             <el-descriptions-item label="仪表性质">
               <CheckboxGroup v-model="data.meter_kind">
                   <Checkbox label="计量表"></Checkbox>
                   <Checkbox label="分摊计费表"></Checkbox>
               </CheckboxGroup>
             </el-descriptions-item>
             <el-descriptions-item label="仪表编号">
               <el-input size="mini" placeholder="仪表编号" v-model="data.dummy_meter_id" clearable></el-input>
             </el-descriptions-item>
             <el-descriptions-item label="收费标准">
               <el-select size="mini" style="width: 100%" v-model="data.charge_id" filterable clearable placeholder="收费标准" class="kuan">
                 <el-option
                   v-for="item in share_like"
                   :key="item.id"
                   :label="item.name"
                   :value="item.id">
                 </el-option>
               </el-select>
             </el-descriptions-item>
            <el-descriptions-item label="仪表名称">
              <el-input size="mini" placeholder="仪表名称" v-model="data.dummy_meter_name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="计费周期">
              <el-date-picker size="mini" v-model="data.s_startDate" type="date" placeholder="开始时间"></el-date-picker>
              <span class="cdj_text_data">至</span>
              <el-date-picker size="mini" v-model="data.e_endDate" type="date" placeholder="结束时间"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="应收日期">
             <el-date-picker size="mini" v-model="data.s_should_charge_date" type="date" placeholder="开始时间"></el-date-picker>
             <span class="cdj_text_data">至</span>
             <el-date-picker size="mini" v-model="data.e_should_charge_date" type="date" placeholder="结束时间"></el-date-picker>
            </el-descriptions-item>
           </el-descriptions>
         </div>

         <!-- 数据列表 -->
         <div style="width: 100%;margin-top: 10px;">
           <el-table ref="multipleTable" :data="tableData" height="50vh" border tooltip-effect="dark" style="position:relative;width: 100%;" @selection-change="handleSelectionChange">
               <el-table-column prop="HouseName" label="所在房产 " width="300"></el-table-column>
               <el-table-column prop="house_number" label="户号"  width="120" ></el-table-column>
               <el-table-column prop="dummy_meter_name" label="仪表名称"  width="120" ></el-table-column>
               <el-table-column prop="last_used_degree" label="上期用量"  width="100" ></el-table-column>
               <el-table-column prop="last_price" label="上期单价 "  width="100" ></el-table-column>
               <el-table-column prop="last_charge_sum" label="上期金额"  width="100"></el-table-column>
               <el-table-column prop="current_used_degree"  label="本期用量" width="100"></el-table-column>
               <el-table-column prop="current_price"  label="本期单价" width="100"></el-table-column>
               <el-table-column prop="current_charge_sum"  label="本期金额" width="100"></el-table-column>
               <el-table-column prop="should_charge_date"  label="应收日期" width="120"></el-table-column>
               <el-table-column prop="calc_start_date"  label="开始日期" width="120"></el-table-column>
               <el-table-column prop="calc_end_date"  label="结束日期" width="120"></el-table-column>
           </el-table>
         </div>
        <v-divider></v-divider>
        <div class="pages">
          <Page :total="total" :page-size="page" @on-change="change"  show-total />
        </div>
      </div>
    </div>
</div>

</template>

<script>
const chargeItem_name_id = [];
export default {
  name: "FormsOweMoney",
  data () {
    return {
      meter_type_list:[],
      tableData: [],
      house:'',
      selectList:[],
      dessertsLog:[],
      totallog:0,
      pagelog:12,
      activeName: 'first',
      startDate:'',
      endDate:'',
      s_startDate:'',
      e_endDate:'',
      chargeitem:[],
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      data:{
        pid:'',
        house_id:'',
        s_startDate:'',
        e_endDate:'',
        chargeitemID:[],
        chargeitem_type_id:'',
        chargeItem_name_id:'',
        status:2,
        days:'2',
        start:'',
        name:'',
        charge_id:'',
        meter_type_id:'',
        house_number:'',
        dummy_meter_id:'',
        dummy_meter_name:'',
        HouseName:'',
        meter_kind:[],
        s_should_charge_date:'',
        e_should_charge_date:'',
      },
      share_like:[],
      chargeItem_name_id:[],
      chargeitem_type:[],
      chargeitem_1:[],
      chargeitem_2:[],
      charge:[],
      charges:[],
      charges1:[],
      homeName:'',
      house:'',
      count:'',
      routineSum:[],
      isIndeterminate: true,
      developer:'',
      discount_type:[],
      timer:'',
      timecount:0,
      ids:'',
      multipleSelection:[],
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    // this.change(1);
    //常规收费项目
    this.$myhttp.get('admin/common/chargeitem_name',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem_1 = backdata.data.data;
        this.chargeitem_2 = backdata.data.data;
    });
    //减免类型
    this.$myhttp.get('admin/common/discount_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.discount_type = backdata.data.data;
    });
    //仪表类型
    this.$myhttp.get('admin/common/meter_type_list',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.meter_type_list = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    //收费标准
    share_charge(){
      this.$myhttp.get('admin/common/share_charge?pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.share_like = backdata.data.data;
      });
    },
    //搜索房产
    remoteMethod(query) {
      if (query !== "") {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get("admin/common/house_text2?text=" +query +"&project_id=" +this.data.pid,{
          "Content-Type": "application/json",
          }).then((backdata) => {
            // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
          });
      } else {
        this.selectList = [];
      }
    },
    //点击收费项目
    chargeItem_names(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.data.chargeItem_name_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.data.chargeitemID = '';
          this.charges = backdata.data.data;
      });
    },
    chargeItem_names1(){
      this.$myhttp.get("admin/RoomSetUp/chargeItem_name?chargeItem_name_id="+this.houesmoney.xsc_ChargeItemID_id+"&pid="+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.houesmoney.chargeitemID = '';
          this.charges1 = backdata.data.data;
      });
    },
    //获得当前多少页,分页
    change(e){
      ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/ShareMeterDegrees/index',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.tableData = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          ERP.hideLoading()
      });
    },

    //搜索
    searchs(){
      this.change(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.HouseName=tree_str;
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.change(1);
      this.chargesc(this.data.pid,this.data.homeName);
      this.share_charge();
    },
    //加载收费项目
    chargesc(pid,homeName){
      this.chargeItem_name_id = [];
      this.$myhttp.get("admin/RoutineExpense/index?pid="+pid+'&homeName='+homeName,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.charge = backdata.data.data.charge;
          this.count = backdata.data.data.count;
          this.chargeItem_name_id = backdata.data.data.chargeItem_name_id;
      });
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10)
    },
  },
  watch:{

  },

  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
.el-checkbox-group{
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Meter/share/MeterOrderSelect.vue